export function createLocalizedValidationMessage(key: string, field?: string[]) {
    return {
        message: key,
        ...(field ? { path: field } : {}),
        params: {
            localize: true,
        },
    }
}
